import { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters."); return; }
    if (password !== confirm) { toast.error("Passwords don't match."); return; }
    setLoading(true);
    try {
      await api.post("/auth/password/reset", { token, new_password: password });
      toast.success("Password updated. Please sign in.");
      navigate("/login", { replace: true });
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] px-6 py-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
        data-testid="reset-page"
      >
        <Link to="/" className="block text-center mb-12">
          <span className="font-display text-3xl tracking-tight text-gold">Wanted</span>
        </Link>
        <div className="glass-strong rounded-3xl p-10">
          <div className="text-gold-soft tracking-overline text-xs mb-3 text-center">RESET PASSWORD</div>
          <h1 className="font-display text-3xl font-light text-center mb-8 leading-tight">Choose a new password.</h1>
          <form onSubmit={submit} className="space-y-4">
            <input
              type="password" required placeholder="New password"
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="input-luxe" data-testid="reset-password-input"
            />
            <input
              type="password" required placeholder="Confirm new password"
              value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="input-luxe" data-testid="reset-confirm-input"
            />
            <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="reset-submit-btn">
              {loading ? "Updating..." : "Update password"}
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
}
